import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {Sprite} from "../core/Sprite";

export class OnboardingArrow extends Container {

    private readonly sprite = this.addChild(new Sprite("onboarding-arrow", {x: 0.5, y: 0.8}));

    constructor() {
        super();

        this.sprite.scale.set(2);
        this.sprite.tweenTo(0.4, Ease.sineInOut, {
            y: -this.sprite.height * 0.5,
            repeat: -1,
            yoyo: true,
        });
    }
}
